import { Component, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { NoteUpd } from '../../shared/models/NoteUpd';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../shared/enums/CRUDActions';
import { CommonFunctions } from '../../shared/static/common-functions';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { MessageInfo } from '../../shared/models/MessageInfo';
import { GlobalsService } from '../../shared/services/globals.service';
import { DispatchAssignmentBus } from '@app/cp/shared/models/DispatchAssignmentBus';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { v_DispatchAssignmentBus } from '@app/cp/shared/models/v_DispatchAssignmentBus';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { GItem } from '../../shared/models/GItem';
import { DispatchPartsBus } from '../../shared/models/DispatchPartsBus';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { InvoiceService } from '../../shared/services/invoice.service';
import { SearchTarget } from '../../shared/enums/SearchTarget';
import { InvoiceMessageInfo } from '../../shared/models/InvoiceMessageInfo';

import { AdditionalInvoiceData } from '../../shared/models/AdditionalInvoiceData';
import { Subscription } from 'rxjs';
import { TaxCodeBus } from '../../shared/models/TaxCodeBus';
import { LineItemsSummary } from '../../shared/models/LineItemsSummary';
import { InvoiceLineItemsComponent } from '../invoice-lineitems/invoice-lineitems.component';
import { v_InvoiceLineItemBus } from '../../shared/models/v_InvoiceLineItemBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'invoice-estimate-dialog',
    templateUrl: './invoice-estimate-dialog.component.html',
    styleUrls: ['./invoice-estimate-dialog.component.scss'],
    standalone: false
})
export class InvoiceEstimateDialogComponent   {

    constructor(public globals: GlobalsService, featureFlagService: FeatureFlagService, private svc_data: DispatchesService, private inv_data: InvoiceService) {
    }

    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    cpLoaderModal: boolean = false;
    cpLoaderIn: boolean = false;
    _parentId: any;
    inventoryLocationId: any;
    parentObj: any = {
        costMaterial: 0,
        costLabor: 0,
        costOther: 0,
        cost: 0,
        saleMaterial: 0,
        saleLabor: 0,
        saleOther: 0,
        amount: 0,
        total: 0,

    };
    lineItemsSummaryany = {
        costMaterial: 0,
        costLabor: 0,
        costOther: 0,
        cost: 0,
        saleMaterial: 0,
        saleLabor: 0,
        saleOther: 0,
        amount: 0,
        total: 0,

    };
    lineItemsVar: v_InvoiceLineItemBus[]=[];
    partId: any;
    inventoryLocationXrefid: any;
    partNumber: string;
    partDescription: string;
    partQuantity:number
    active: boolean = false;
    inventorySearch: boolean = false;
    data: any;
    gridData: v_DispatchAssignmentBus[];
    action: CRUDActions;
    techId: string;
    assignmentDateTime: Date;
    code: string;
    invoiceData: any;
    addtlData : AdditionalInvoiceData
    @Input() title: string;
    @Input() message: string;
    @Output() confirmation: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();
    @Input() sublings: GItem[] = [];
    @ViewChild("LineItems") invoiceLineItemsComponent: InvoiceLineItemsComponent;
    truckList: GItem[] = []
    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action = CRUDActions.None;

    }
    parentMessage(evt: any) {
        //noop
    }
    ok() {
        let result: ConfirmOutput = {
            action: this.action, dialogResult: CPDialogResult.ok, data: { techId: this.techId, assignmentDateTime: this.assignmentDateTime}, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    cancel() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    public show(id: any, searchTarget :SearchTarget ) {

        this.active = true;
        this._parentId = id;
        this.cpLoaderIn = true;
        this.inv_data.dispatchInvoiceEstimate(searchTarget, id).subscribe((info: InvoiceMessageInfo) => {
            if (!info.saveError) {

                this.addtlData = new AdditionalInvoiceData(info.dcValues.addtlData);
                this.invoiceData = info.invoice;
                this.taxCode = info.dcValues.addtlData.taxCode;
                this.setTaxCode(this.invoiceData.taxCodeId); //1 this.addtlData);
                this.lineItemsVar = this.addtlData.lineItems;

                this.lineItemsSummary = info.dcValues.addtlData.lineItemsSummary;
                this.invoiceLineItemsComponent.sumAggregates();
                this.invoiceLineItemsComponent.sumGrid();
                setTimeout(() => {                           //<<<---using ()=> syntax
                    this.invoiceLineItemsComponent.sumGrid();
                    this.cpLoaderIn = false;
                }, 500);

            }

        });

    }
    searchParts() {
        if (this.inventoryLocationId) {
            this.inventorySearch = true;
        }
    }

    taxCode: TaxCodeBus
    lineItemsSummary: LineItemsSummary;
    subs_getTaxCode: Subscription;
    setTaxCode(id: any) {
        if (id) {
            CommonFunctions.unsubscribe(this.subs_getTaxCode);
            this.subs_getTaxCode = this.inv_data.getTaxCode(id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                        this.taxCode= info.primaryReturn;
                    }

            });
        }

    }

    public getNewPart() {

        let dispatchPartsBus: DispatchPartsBus = new DispatchPartsBus();

        var selecttruck = this.truckList.find(ev => ev.value === this.inventoryLocationId)
        if (selecttruck) {

            dispatchPartsBus.personId = selecttruck.category;

        }

        dispatchPartsBus.dispatchPartId = '00000000-0000-0000-0000-000000000000';
        //     dispatchPartsBus.dispatchId =
        dispatchPartsBus.inventoryLocationXrefid = this.inventoryLocationXrefid;
        dispatchPartsBus.inventoryLocationId = this.inventoryLocationId;
        dispatchPartsBus.inventoryId = this.partId;
        dispatchPartsBus.quantity = this.partQuantity;
        dispatchPartsBus.addedDate = new Date (Date.now());
        dispatchPartsBus.insertDt = new Date(Date.now());
        dispatchPartsBus.updateDt = new Date(Date.now());

        return dispatchPartsBus;

    }
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    inventorySelected(value: any) {

        this.inventorySearch = false;
        if (value != null) {
            this.partId = value.InventoryId;
            this.inventoryLocationXrefid = value.InventoryLocationXREFId;
            this.partNumber = value.Number;
            this.partDescription = value.FullDescription;
        }
        else {
            this.inventorySearch = false;
        }

    }
}

